import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FreudSelectModule } from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';

import { FrequencySelectComponent } from './frequency-select.component';

@NgModule({
	declarations: [FrequencySelectComponent],
	imports: [
		CommonModule,
		FormsModule,
		FreudSelectModule,
		TranslateModule.forChild(),
	],
	exports: [FrequencySelectComponent],
})
export class FrequencySelectModule {}
